import clsx from 'clsx';
import { ComponentPropsWithRef } from 'react';
import {
  selectionTag,
  selectionTagSize,
  type SelectionTagSize,
} from './selection-tag.css';

export type { SelectionTagSize };

export type SelectionTagProps = ComponentPropsWithRef<'button'> & {
  checked?: boolean;
  size?: SelectionTagSize;
};

export const SelectionTag = ({
  className,
  checked,
  size = 'md',
  ...props
}: SelectionTagProps) => {
  return (
    <button
      type="button"
      role="checkbox"
      className={clsx(className, selectionTag, selectionTagSize[size])}
      aria-checked={checked}
      {...props}
    />
  );
};
